"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _axios = _interopRequireDefault(require("axios"));
var _lib = _interopRequireDefault(require("@xto10x/storage/lib"));
var _getSignedInWith = _interopRequireDefault(require("@xto10x/oauth2/lib/getSignedInWith"));
var _getCredentials = _interopRequireDefault(require("@xto10x/oauth2/lib/getCredentials"));
var _getCredentialsSync = _interopRequireDefault(require("@xto10x/oauth2/lib/getCredentialsSync"));
var _renewCredentials = _interopRequireDefault(require("@xto10x/oauth2/lib/renewCredentials"));
var _clearCredentials = _interopRequireDefault(require("@xto10x/oauth2/lib/clearCredentials"));
var _analytics = _interopRequireDefault(require("@xto10x/core/lib/analytics"));
var _config = _interopRequireWildcard(require("./config"));
var _app = require("./app.utils");
var _constants = require("./constants");
var _networkUtils = require("./networkUtils");
var _api = require("./api.config");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
_axios["default"].defaults.baseURL = _config["default"].apiURL;
_axios["default"].defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
_axios["default"].defaults.headers.put['Content-Type'] = 'application/json;charset=UTF-8';
var authToken = '';
var shouldIgnoreError = function shouldIgnoreError(url) {
  var ignoreList = ['/v1/access'];
  return ignoreList.includes(url);
};
var getTimeout = function getTimeout() {
  var _getHttpClientConfig;
  return ((_getHttpClientConfig = (0, _api.getHttpClientConfig)()) === null || _getHttpClientConfig === void 0 || (_getHttpClientConfig = _getHttpClientConfig.apiHandlerConfig) === null || _getHttpClientConfig === void 0 ? void 0 : _getHttpClientConfig.timeout) || 8000;
};
var getSignoutUrl = function getSignoutUrl() {
  return _config["default"].signoutRedirectUrl.replace('_REDIRECT_URL_', encodeURIComponent(window.location.href));
};
var validateHeaders = function validateHeaders() {
  var _storage$getDataFromL;
  var hdr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var useBlitzProductId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var headers = hdr;
  if ((0, _app.isEmptyString)(headers.ORG_ID) && (0, _app.isNotEmptyString)((_storage$getDataFromL = _lib["default"].getDataFromLocal(_constants.StorageKey.ORG_INFO)) === null || _storage$getDataFromL === void 0 ? void 0 : _storage$getDataFromL.org_reference_id)) {
    headers.ORG_ID = _lib["default"].getDataFromLocal(_constants.StorageKey.ORG_INFO).org_reference_id;
  }
  if ((0, _app.isEmptyString)(headers.PRODUCT_ID)) {
    headers.PRODUCT_ID = _lib["default"].getDataFromLocal(_constants.StorageKey.PRODUCT_ID) ? _lib["default"].getDataFromLocal(_constants.StorageKey.PRODUCT_ID) : 'OKR';
    if (useBlitzProductId) headers.PRODUCT_ID = 'apps';
    headers.PRODUCT_ID = headers.PRODUCT_ID.toLowerCase();
  }
  if ((0, _app.isEmptyString)(headers.REQUESTER_USER_ID) && (0, _app.isNotEmptyString)(_lib["default"].getDataFromLocal(_constants.StorageKey.REQUESTER_USER_ID))) {
    headers.REQUESTER_USER_ID = _lib["default"].getDataFromLocal(_constants.StorageKey.REQUESTER_USER_ID);
  }
  var ACCESS_TOKEN = (0, _getCredentialsSync["default"])();
  headers.Authorization = ACCESS_TOKEN || authToken;
  return headers;
};
var retryNetworkCall = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(api_config) {
    var new_api_config, ACCESS_TOKEN, credentials, _t;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          new_api_config = (0, _app.clone)(api_config);
          new_api_config.headers.isRetried = true;
          ACCESS_TOKEN = '';
          _context.prev = 1;
          _context.next = 2;
          return (0, _getCredentials["default"])();
        case 2:
          credentials = _context.sent;
          ACCESS_TOKEN = credentials.idToken;
          authToken = ACCESS_TOKEN;
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
        case 4:
          if ((0, _app.isNotEmptyString)(ACCESS_TOKEN)) new_api_config.headers.Authorization = ACCESS_TOKEN;
          return _context.abrupt("return", _axios["default"].request(new_api_config));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function retryNetworkCall(_x) {
    return _ref.apply(this, arguments);
  };
}();
var signInMode = null;
var reAuthenticateResponse = null;
var authenticationStatus = 0;
var reAuthenticate = function reAuthenticate() {
  if (!reAuthenticateResponse && !authenticationStatus) {
    signInMode = (0, _getSignedInWith["default"])();
    reAuthenticateResponse = (0, _renewCredentials["default"])()["catch"](function (err) {
      _analytics["default"].trackError("http_renew_creds_error ".concat(signInMode), err, true, true);
      _lib["default"].clearAllStorage(false, _constants.StorageKey.REVIEW_LAST_PAGE, _constants.StorageKey.REVIEW_DRAFT_DATA);
      _clearCredentials["default"].all();
      window.location.href = getSignoutUrl();
    })["finally"](function () {
      authenticationStatus = 0;
      reAuthenticateResponse = null;
    });
    authenticationStatus = 1;
  }
  return reAuthenticateResponse;
};
var authenticateAndRetry = function authenticateAndRetry(api_config) {
  return reAuthenticate().then(function () {
    return retryNetworkCall(api_config);
  });
};
function requestInterceptor(request) {
  if (_config.DEBUG) {
    // eslint-disable-next-line no-console
    console.log("Request: ".concat(request.method, " : ").concat(request.url), {
      url: request.url,
      method: request.method,
      data: request.data,
      params: JSON.stringify(request.params),
      headers: JSON.stringify(request.headers),
      baseURL: request.baseURL
    });
  }
  return request;
}
function responseInterceptor(response) {
  if (_config.DEBUG) {
    // eslint-disable-next-line no-console
    console.log("Response: ".concat(response.config.method, " : ").concat(response.config.url), {
      url: response.config.url,
      params: JSON.stringify(response.config.params),
      status: response.status,
      data: JSON.stringify(response.data),
      headers: JSON.stringify(response.headers)
    });
  }
  return response;
}
function handleResponseError(e) {
  var _httpClientConfig$err2;
  if (!_config.isProdEnvironment) console.log('httpClient.error', e.config.url, JSON.stringify(e));
  if (shouldIgnoreError(e.config.url)) {
    return Promise.resolve();
  }
  var error = e;
  error.log = e.message;
  var productId = e.config.headers.PRODUCT_ID || e.config.headers.product_id;
  var httpClientConfig = (0, _api.getHttpClientConfig)(productId);
  if (!_config.isProdEnvironment) console.log('http_client_config', httpClientConfig);
  var status_code = error.response ? error.response.status : null;
  if (error.config.headers.isRetried == null && (status_code && status_code === 401 || error.message.includes('status code 401'))) {
    return authenticateAndRetry(error.config);
  }
  if (error.response && error.response.data) {
    var _httpClientConfig$err;
    if (error.response.data.code) e.message = (httpClientConfig === null || httpClientConfig === void 0 || (_httpClientConfig$err = httpClientConfig.errorCodes) === null || _httpClientConfig$err === void 0 ? void 0 : _httpClientConfig$err[error.response.data ? error.response.data.code : 'default']) || 'An error has occurred. Please try again after some time';else {
      e.message = error.response.data.message ? error.response.data.message : e.message;
    }
  } else if (error && error.code && error.code === 'ECONNABORTED') e.message = (httpClientConfig === null || httpClientConfig === void 0 || (_httpClientConfig$err2 = httpClientConfig.errorCodes) === null || _httpClientConfig$err2 === void 0 ? void 0 : _httpClientConfig$err2['timeout']) || 'Please check your network connection and try again.';
  if (error.response && error.response.data && error.response.data.code) {
    var _httpClientConfig$api, _httpClientConfig$api2;
    var refresh_error_codes = httpClientConfig === null || httpClientConfig === void 0 || (_httpClientConfig$api = httpClientConfig.apiHandlerConfig) === null || _httpClientConfig$api === void 0 ? void 0 : _httpClientConfig$api.refresh_error_codes;
    var sign_out_error_codes = httpClientConfig === null || httpClientConfig === void 0 || (_httpClientConfig$api2 = httpClientConfig.apiHandlerConfig) === null || _httpClientConfig$api2 === void 0 ? void 0 : _httpClientConfig$api2.sign_out_error_codes;
    if (sign_out_error_codes && sign_out_error_codes.includes(error.response.data.code)) {
      setTimeout(function () {
        _lib["default"].clearAllStorage(false, _constants.StorageKey.REVIEW_LAST_PAGE, _constants.StorageKey.REVIEW_DRAFT_DATA);
        _clearCredentials["default"].all();
        window.location.href = getSignoutUrl();
      }, 100);
    } else if (refresh_error_codes && refresh_error_codes.includes(error.response.data.code)) {
      _analytics["default"].trackEvent('manual_page_reload', "refresh_code_match_page_reload".concat(error.response.data.code ? "_".concat(error.response.data.code) : ''));
      setTimeout(function () {
        window.location.reload();
      }, 100);
    } else {
      _analytics["default"].trackError('api_error', error, false, false);
    }
  } else {
    _analytics["default"].trackError('api_error', error, false, false);
  }
  if (_config.DEBUG) {
    // eslint-disable-next-line no-console
    console.log("Error: ".concat(error.config.method, " : ").concat(error.config.url), {
      url: error.config.url,
      message: error.message,
      stack: error.stack,
      log: error.log,
      response: error.response && error.response.data ? JSON.stringify(error.response.data) : null,
      params: JSON.stringify(error.config.params),
      headers: JSON.stringify(error.config.headers),
      error: JSON.stringify(error)
    });
  }
  return Promise.reject(error);
}
_axios["default"].interceptors.request.use(requestInterceptor);
_axios["default"].interceptors.response.use(responseInterceptor, handleResponseError);
var httpClient = {
  get: function get(path) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var useBlitzProductId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    return (0, _networkUtils.isNetworkActiveAsync)().then(function (online) {
      if (online) return _axios["default"].get(path, _objectSpread({
        timeout: getTimeout(),
        params: params,
        headers: validateHeaders(headers, useBlitzProductId)
      }, options));
      return Promise.reject(new Error('Please check your network connection and try again.'));
    });
  },
  post: function post(path, data) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var useBlitzProductId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    return (0, _networkUtils.isNetworkActiveAsync)().then(function (online) {
      if (online) return _axios["default"].post(path, data, {
        timeout: getTimeout(),
        params: params,
        headers: validateHeaders(headers, useBlitzProductId)
      });
      return Promise.reject(new Error('Please check your network connection and try again.'));
    });
  },
  patch: function patch(path, data) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var useBlitzProductId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    return (0, _networkUtils.isNetworkActiveAsync)().then(function (online) {
      if (online) return _axios["default"].patch(path, data, {
        timeout: getTimeout(),
        params: params,
        headers: validateHeaders(headers, useBlitzProductId)
      });
      return Promise.reject(new Error('Please check your network connection and try again.'));
    });
  },
  put: function put(path, data) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var useBlitzProductId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    return (0, _networkUtils.isNetworkActiveAsync)().then(function (online) {
      if (online) return _axios["default"].put(path, data, {
        timeout: getTimeout(),
        params: params,
        headers: validateHeaders(headers, useBlitzProductId)
      });
      return Promise.reject(new Error('Please check your network connection and try again.'));
    });
  },
  "delete": function _delete(path, data) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var useBlitzProductId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    return (0, _networkUtils.isNetworkActiveAsync)().then(function (online) {
      if (online) return _axios["default"]["delete"](path, {
        timeout: getTimeout(),
        data: data,
        params: params,
        headers: validateHeaders(headers, useBlitzProductId)
      });
      return Promise.reject(new Error('Please check your network connection and try again.'));
    });
  }
};
var _default = exports["default"] = httpClient;